module.exports = __webpack_public_path__ + "img/02-pic.c640499c.png";